export default __webpack_public_path__ + "static/media/dark_layout.25ed1723.jpg";